import { render, staticRenderFns } from "./RedeemButton.vue?vue&type=template&id=2fc2368e&"
import script from "./RedeemButton.vue?vue&type=script&lang=js&"
export * from "./RedeemButton.vue?vue&type=script&lang=js&"
import style0 from "./RedeemButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports